var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"binding"}),_c('div',{staticClass:"pad"},[_c('div',{staticClass:"line line1"}),_c('div',{staticClass:"line line2"}),_c('div',{staticClass:"line line3"}),_c('div',{staticClass:"line line4"}),_c('div',{staticClass:"line line5"}),_c('div',{staticClass:"line line6"})])])
}]

export { render, staticRenderFns }